// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__2FkMM","background":"style_background__3_7Dg"};